import { render } from "./confirmation-form.vue?vue&type=template&id=36c005cc&scoped=true"
import script from "./confirmation-form.vue?vue&type=script&lang=js"
export * from "./confirmation-form.vue?vue&type=script&lang=js"

import "./confirmation-form.vue?vue&type=style&index=0&id=36c005cc&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36c005cc"]])

export default __exports__